<template>
  <section class="blog">
    <div class="heading">
      <div class="heading-container">
        <h3>our blog</h3>
        <p>
          <router-link :to="{ name: 'Home' }" class="home text-decoration-none"
            >home</router-link
          >
          / <span>blog</span>
        </p>
      </div>
    </div>
    <div class="blog-container">
      <h1 class="title">
        <span>our blog</span>
        <a class="text-decoration-none" href=""> view all >></a>
      </h1>
      <div class="box-container">
        <div v-for="blog in blogs" :key="blog.id" class="box">
          <div class="image">
            <img :src="blog.image" alt="" />
          </div>
          <div class="content">
            <h3>{{ blog.title }}</h3>
            <p>{{ blog.description }}</p>
            <router-link to="#" class="btn">read more</router-link>
            <div class="icons">
              <router-link to="" class="icon text-decoration-none">
                <font-awesome-icon icon="calendar" /> {{ blog.created }}
              </router-link>
              <router-link to="" class="icon text-decoration-none">
                <font-awesome-icon icon="user" /> by {{ blog.createdBy }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const dummyData = {
  blogs: [
    {
      id: "1",
      title: "blog title goes here...",
      image: require("@/images/blog-1.jpg"),
      description:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat,harum.",
      created: "21st may, 2021",
      createdBy: "admin",
    },
    {
      id: "2",
      title: "blog title goes here...",
      image: require("@/images/blog-2.jpg"),
      description:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat,harum.",
      created: "21st may, 2021",
      createdBy: "admin",
    },
    {
      id: "3",
      title: "blog title goes here...",
      image: require("@/images/blog-3.jpg"),
      description:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat,harum.",
      created: "21st may, 2021",
      createdBy: "admin",
    },
    {
      id: "4",
      title: "blog title goes here...",
      image: require("@/images/blog-4.jpg"),
      description:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat,harum.",
      created: "21st may, 2021",
      createdBy: "admin",
    },
    {
      id: "5",
      title: "blog title goes here...",
      image: require("@/images/blog-5.jpg"),
      description:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat,harum.",
      created: "21st may, 2021",
      createdBy: "admin",
    },
    {
      id: "6",
      title: "blog title goes here...",
      image: require("@/images/blog-6.jpg"),
      description:
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat,harum.",
      created: "21st may, 2021",
      createdBy: "admin",
    },
  ],
};

export default {
  data() {
    return {
      blogs: [],
    };
  },
  created() {
    this.fetchBlogs();
  },
  methods: {
    fetchBlogs() {
      this.blogs = dummyData.blogs;
    },
  },
};
</script>